<div class="w-full max-w-full">
  
  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white">Subskrypcje</h1>
    <p class="text-gray-600 dark:text-gray-400 mt-1">Zarządzaj planami i porównaniem funkcjonalności</p>
  </div>

  <!-- Loading state -->
  <div *ngIf="isLoading" class="flex items-center justify-center py-20">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <!-- Content with Tabs -->
  <mat-tab-group *ngIf="!isLoading" animationDuration="200ms" class="custom-tabs" [selectedIndex]="2">
    
    <!-- Tab: Plany subskrypcji -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon [svgIcon]="'tabler_outline:package'" class="mr-2"></mat-icon>
        Plany subskrypcji
      </ng-template>

      <div class="pt-6">
        <!-- Header z przyciskiem -->
        <div class="flex items-center justify-between mb-6">
          <div></div>
          <button 
            mat-raised-button 
            color="primary"
            (click)="openCreateDialog()"
            class="!rounded-lg">
            <mat-icon [svgIcon]="'tabler_outline:plus'" class="mr-2"></mat-icon>
            Dodaj plan
          </button>
        </div>

        <!-- Stats Cards -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div class="bg-card rounded-xl shadow-sm p-4 border border-gray-200 dark:border-gray-700">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                <mat-icon [svgIcon]="'tabler_outline:package'" class="text-blue-600 dark:text-blue-400"></mat-icon>
              </div>
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Wszystkie plany</p>
                <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ plans.length }}</p>
              </div>
            </div>
          </div>
          
          <div class="bg-card rounded-xl shadow-sm p-4 border border-gray-200 dark:border-gray-700">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                <mat-icon [svgIcon]="'tabler_outline:circle-check'" class="text-green-600 dark:text-green-400"></mat-icon>
              </div>
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Aktywne</p>
                <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ activePlansCount }}</p>
              </div>
            </div>
          </div>
          
          <div class="bg-card rounded-xl shadow-sm p-4 border border-gray-200 dark:border-gray-700">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg">
                <mat-icon [svgIcon]="'tabler_outline:tag'" class="text-amber-600 dark:text-amber-400"></mat-icon>
              </div>
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Z rabatem</p>
                <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ discountedPlansCount }}</p>
              </div>
            </div>
          </div>
          
          <div class="bg-card rounded-xl shadow-sm p-4 border border-gray-200 dark:border-gray-700">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg">
                <mat-icon [svgIcon]="'tabler_outline:crown'" class="text-purple-600 dark:text-purple-400"></mat-icon>
              </div>
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Płatne</p>
                <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ paidPlansCount }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Plans Table -->
        <div class="bg-card rounded-2xl shadow-lg overflow-hidden">
          
          <!-- Table header -->
          <div class="p-6 border-b dark:border-gray-700">
            <div class="flex items-center gap-3">
              <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Lista planów</h2>
              <span class="px-3 py-1 text-sm font-medium rounded-full bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                {{ plans.length }}
              </span>
            </div>
          </div>

          <!-- Empty state -->
          <div *ngIf="plans.length === 0" class="p-12 text-center">
            <mat-icon class="text-6xl text-gray-400 mb-4" [svgIcon]="'tabler_outline:package'"></mat-icon>
            <h3 class="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">
              Brak planów subskrypcji
            </h3>
            <p class="text-gray-500 dark:text-gray-400 mb-6">
              Utwórz pierwszy plan abonamentowy
            </p>
            <button 
              mat-raised-button 
              color="primary"
              (click)="openCreateDialog()"
              class="!rounded-lg">
              <mat-icon [svgIcon]="'tabler_outline:plus'" class="mr-2"></mat-icon>
              Dodaj plan
            </button>
          </div>

          <!-- Table -->
          <div *ngIf="plans.length > 0" class="overflow-x-auto">
            <table mat-table [dataSource]="plans" class="w-full">

              <!-- Stage Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">Stage</th>
                <td mat-cell *matCellDef="let plan">
                  <span 
                    class="px-3 py-1 rounded-full text-xs font-bold"
                    [ngClass]="getTypeColor(plan.stage)">
                    {{ getTypeLabel(plan.stage) }}
                  </span>
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="font-semibold">Nazwa</th>
                <td mat-cell *matCellDef="let plan">
                  <div>
                    <div class="font-medium text-gray-900 dark:text-white">
                      {{ plan.name }}
                    </div>
                    <div class="text-sm text-gray-500 dark:text-gray-400 line-clamp-1">
                      {{ plan.description || 'Brak opisu' }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Price Column -->
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-40">Cena</th>
                <td mat-cell *matCellDef="let plan">
                  <div class="flex flex-col">
                    <span class="font-semibold text-gray-900 dark:text-white">
                      {{ formatPrice(plan.price) }}
                    </span>
                    <ng-container *ngIf="hasDiscount(plan)">
                      <span class="text-sm line-through text-gray-400">
                        {{ formatPrice(plan.originalPrice) }}
                      </span>
                      <span class="text-xs text-green-600 dark:text-green-400 font-medium">
                        -{{ plan.discountPercent }}% rabatu
                      </span>
                    </ng-container>
                  </div>
                </td>
              </ng-container>

              <!-- Duration Column -->
              <ng-container matColumnDef="duration">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">Okres</th>
                <td mat-cell *matCellDef="let plan">
                  <span class="text-gray-600 dark:text-gray-300">
                    {{ formatDuration(plan) }}
                  </span>
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">Status</th>
                <td mat-cell *matCellDef="let plan">
                  <span 
                    class="px-3 py-1 rounded-full text-xs font-semibold inline-flex items-center gap-1"
                    [ngClass]="{
                      'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400': plan.isActive,
                      'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300': !plan.isActive
                    }">
                    <mat-icon 
                      class="!w-4 !h-4 !text-sm" 
                      [svgIcon]="plan.isActive ? 'tabler_outline:circle-check' : 'tabler_outline:circle-x'">
                    </mat-icon>
                    {{ plan.isActive ? 'Aktywny' : 'Nieaktywny' }}
                  </span>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="font-semibold text-right w-16"></th>
                <td mat-cell *matCellDef="let plan" class="text-right" (click)="$event.stopPropagation()">
                  <button 
                    mat-icon-button
                    color="primary"
                    (click)="openEditDialog(plan)"
                    matTooltip="Edytuj plan"
                    class="!text-primary-600 dark:!text-primary-400">
                    <mat-icon [svgIcon]="'tabler_outline:edit'"></mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr 
                mat-row 
                *matRowDef="let row; columns: displayedColumns;" 
                (click)="openEditDialog(row)"
                class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors cursor-pointer"></tr>
            </table>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab: Porównanie funkcjonalności -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon [svgIcon]="'tabler_outline:list-check'" class="mr-2"></mat-icon>
        Porównanie funkcjonalności
        <span *ngIf="featuresHasChanges" class="ml-2 w-2 h-2 rounded-full bg-amber-500"></span>
      </ng-template>

      <div class="pt-6">
        <!-- Header -->
        <div class="flex items-center justify-between mb-6">
          <div>
            <p class="text-sm text-gray-500 dark:text-gray-400">
              Edytuj tabelkę porównania funkcjonalności wyświetlaną na stronie cennika.
              Pierwszy wiersz (Limit dokumentów) jest generowany automatycznie z planów.
            </p>
          </div>
          <div class="flex items-center gap-3">
            <button 
              mat-stroked-button
              (click)="addFeature()"
              class="!rounded-lg">
              <mat-icon [svgIcon]="'tabler_outline:plus'" class="mr-2"></mat-icon>
              Dodaj wiersz
            </button>
            <button 
              mat-raised-button 
              color="primary"
              (click)="saveFeatures()"
              [disabled]="isFeaturesSaving || !featuresHasChanges"
              class="!rounded-lg">
              <mat-icon [svgIcon]="'tabler_outline:device-floppy'" class="mr-2"></mat-icon>
              <span *ngIf="!isFeaturesSaving">Zapisz zmiany</span>
              <mat-spinner *ngIf="isFeaturesSaving" diameter="20"></mat-spinner>
            </button>
          </div>
        </div>

        <!-- Features Table -->
        <div class="bg-card rounded-2xl shadow-lg overflow-hidden">
          
          <!-- Table header -->
          <div class="p-6 border-b dark:border-gray-700">
            <div class="flex items-center gap-3">
              <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Funkcjonalności</h2>
              <span class="px-3 py-1 text-sm font-medium rounded-full bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                {{ features.length }}
              </span>
            </div>
          </div>

          <!-- Loading -->
          <div *ngIf="isFeaturesLoading" class="p-12 text-center">
            <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
          </div>

          <!-- Empty state -->
          <div *ngIf="!isFeaturesLoading && features.length === 0" class="p-12 text-center">
            <mat-icon class="text-6xl text-gray-400 mb-4" [svgIcon]="'tabler_outline:list-check'"></mat-icon>
            <h3 class="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">
              Brak funkcjonalności
            </h3>
            <p class="text-gray-500 dark:text-gray-400 mb-6">
              Dodaj pierwszą funkcjonalność do porównania
            </p>
            <button 
              mat-raised-button 
              color="primary"
              (click)="addFeature()"
              class="!rounded-lg">
              <mat-icon [svgIcon]="'tabler_outline:plus'" class="mr-2"></mat-icon>
              Dodaj wiersz
            </button>
          </div>

          <!-- Features Edit Table -->
          <div *ngIf="!isFeaturesLoading && features.length > 0" class="overflow-x-auto">
            <table class="w-full min-w-[900px]">
              <thead>
                <tr class="bg-gray-50 dark:bg-gray-800">
                  <th class="py-3 px-4 text-left text-sm font-semibold text-gray-700 dark:text-gray-200 w-10"></th>
                  <th class="py-3 px-4 text-left text-sm font-semibold text-gray-700 dark:text-gray-200 w-64">Funkcjonalność</th>
                  <th class="py-3 px-4 text-center text-sm font-semibold text-gray-500 w-40">FREE</th>
                  <th class="py-3 px-4 text-center text-sm font-semibold text-primary-600 bg-primary-50 dark:bg-primary-900/20 w-40">START</th>
                  <th class="py-3 px-4 text-center text-sm font-semibold text-gray-700 dark:text-gray-200 w-40">PRO</th>
                  <th class="py-3 px-4 text-center text-sm font-semibold text-purple-600 w-40">BUSINESS</th>
                  <th class="py-3 px-4 text-center text-sm font-semibold text-gray-500 w-16"></th>
                </tr>
              </thead>
              <tbody cdkDropList (cdkDropListDropped)="dropFeature($event)">
                <tr *ngFor="let feature of features; let i = index; let odd = odd"
                    cdkDrag
                    [ngClass]="{'bg-gray-50/50 dark:bg-gray-800/30': odd}"
                    class="border-b border-gray-100 dark:border-gray-700/50 hover:bg-gray-100/50 dark:hover:bg-gray-800/50">
                  
                  <!-- Drag handle -->
                  <td class="py-2 px-4 cursor-move" cdkDragHandle>
                    <mat-icon [svgIcon]="'tabler_outline:grip-vertical'" class="text-gray-400 icon-size-5"></mat-icon>
                  </td>

                  <!-- Name -->
                  <td class="py-2 px-4">
                    <input 
                      type="text"
                      [(ngModel)]="feature.name"
                      (ngModelChange)="onFeatureChange()"
                      placeholder="Nazwa funkcjonalności"
                      class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 focus:ring-2 focus:ring-primary-500 focus:border-primary-500">
                  </td>

                  <!-- FREE -->
                  <td class="py-2 px-4">
                    <div class="flex flex-col gap-1">
                      <select 
                        [(ngModel)]="feature.freeType"
                        (ngModelChange)="onFeatureChange()"
                        class="w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800">
                        <option value="true">✓ Tak</option>
                        <option value="false">✗ Nie</option>
                        <option value="custom"># Własne</option>
                      </select>
                      <input 
                        *ngIf="feature.freeType === 'custom'"
                        type="text"
                        [(ngModel)]="feature.freeCustom"
                        (ngModelChange)="onFeatureChange()"
                        placeholder="Wartość"
                        class="w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800">
                    </div>
                  </td>

                  <!-- START -->
                  <td class="py-2 px-4 bg-primary-50/30 dark:bg-primary-900/10">
                    <div class="flex flex-col gap-1">
                      <select 
                        [(ngModel)]="feature.startType"
                        (ngModelChange)="onFeatureChange()"
                        class="w-full px-2 py-1.5 text-sm border border-primary-300 dark:border-primary-700 rounded-lg bg-white dark:bg-gray-800">
                        <option value="true">✓ Tak</option>
                        <option value="false">✗ Nie</option>
                        <option value="custom"># Własne</option>
                      </select>
                      <input 
                        *ngIf="feature.startType === 'custom'"
                        type="text"
                        [(ngModel)]="feature.startCustom"
                        (ngModelChange)="onFeatureChange()"
                        placeholder="Wartość"
                        class="w-full px-2 py-1.5 text-sm border border-primary-300 dark:border-primary-700 rounded-lg bg-white dark:bg-gray-800">
                    </div>
                  </td>

                  <!-- PRO -->
                  <td class="py-2 px-4">
                    <div class="flex flex-col gap-1">
                      <select 
                        [(ngModel)]="feature.proType"
                        (ngModelChange)="onFeatureChange()"
                        class="w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800">
                        <option value="true">✓ Tak</option>
                        <option value="false">✗ Nie</option>
                        <option value="custom"># Własne</option>
                      </select>
                      <input 
                        *ngIf="feature.proType === 'custom'"
                        type="text"
                        [(ngModel)]="feature.proCustom"
                        (ngModelChange)="onFeatureChange()"
                        placeholder="Wartość"
                        class="w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800">
                    </div>
                  </td>

                  <!-- BUSINESS -->
                  <td class="py-2 px-4">
                    <div class="flex flex-col gap-1">
                      <select 
                        [(ngModel)]="feature.businessType"
                        (ngModelChange)="onFeatureChange()"
                        class="w-full px-2 py-1.5 text-sm border border-purple-300 dark:border-purple-700 rounded-lg bg-white dark:bg-gray-800">
                        <option value="true">✓ Tak</option>
                        <option value="false">✗ Nie</option>
                        <option value="custom"># Własne</option>
                      </select>
                      <input 
                        *ngIf="feature.businessType === 'custom'"
                        type="text"
                        [(ngModel)]="feature.businessCustom"
                        (ngModelChange)="onFeatureChange()"
                        placeholder="Wartość"
                        class="w-full px-2 py-1.5 text-sm border border-purple-300 dark:border-purple-700 rounded-lg bg-white dark:bg-gray-800">
                    </div>
                  </td>

                  <!-- Actions -->
                  <td class="py-2 px-4 text-center">
                    <button 
                      mat-icon-button
                      (click)="removeFeature(i)"
                      matTooltip="Usuń wiersz"
                      class="!text-red-500 hover:!bg-red-50 dark:hover:!bg-red-900/20">
                      <mat-icon [svgIcon]="'tabler_outline:trash'" class="icon-size-5"></mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Info -->
          <div class="p-4 bg-gray-50 dark:bg-gray-800/50 border-t dark:border-gray-700">
            <div class="flex items-start gap-2 text-sm text-gray-500 dark:text-gray-400">
              <mat-icon [svgIcon]="'tabler_outline:info-circle'" class="icon-size-5 flex-shrink-0 mt-0.5"></mat-icon>
              <div>
                <p><strong>Podpowiedź:</strong> Przeciągnij wiersze, aby zmienić kolejność. Pierwszy wiersz "Limit dokumentów / miesiąc" jest generowany automatycznie i nie można go edytować tutaj.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </mat-tab>

    <!-- Tab: Zamówienia -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon [svgIcon]="'tabler_outline:shopping-cart'" class="mr-2"></mat-icon>
        Zamówienia
        <!-- Badge: oczekujące płatności -->
        <span *ngIf="pendingOrdersCount > 0" class="ml-2 px-2 py-0.5 text-xs font-bold rounded-full bg-amber-500 text-white"
              matTooltip="Oczekujące płatności">
          {{ pendingOrdersCount }}
        </span>
        <!-- Badge: akcje do wykonania (brak faktury lub do wysłania do KSeF) -->
        <span *ngIf="actionsRequiredCount > 0" class="ml-1 px-2 py-0.5 text-xs font-bold rounded-full bg-red-500 text-white"
              matTooltip="Akcje do wykonania: {{ paidWithoutInvoiceCount }} bez faktury, {{ invoiceToSendToKsefCount }} do wysłania do KSeF">
          {{ actionsRequiredCount }}
        </span>
      </ng-template>

      <div class="pt-6">
        <!-- Header z wyszukiwaniem -->
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
          <div class="flex-1">
            <mat-form-field appearance="fill" class="w-full md:w-80">
              <mat-label>Szukaj zamówienia</mat-label>
              <mat-icon matPrefix [svgIcon]="'tabler_outline:search'" class="mr-2"></mat-icon>
              <input 
                matInput 
                [(ngModel)]="ordersSearchTerm" 
                (ngModelChange)="filterOrders()"
                placeholder="Numer, NIP lub nazwa firmy...">
              <button 
                *ngIf="ordersSearchTerm" 
                mat-icon-button 
                matSuffix 
                (click)="clearOrdersSearch()"
                matTooltip="Wyczyść">
                <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
              </button>
            </mat-form-field>
          </div>
          <button 
            mat-stroked-button
            (click)="refreshOrders()"
            class="!rounded-lg">
            <mat-icon [svgIcon]="'tabler_outline:refresh'" class="mr-2"></mat-icon>
            Odśwież
          </button>
        </div>

        <!-- Stats Cards - klikalne -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <!-- Wszystkie -->
          <div 
            (click)="setOrdersStatusFilter('all')"
            class="bg-card rounded-xl shadow-sm p-4 border-2 transition-all cursor-pointer hover:shadow-md"
            [ngClass]="{
              'border-blue-500 ring-2 ring-blue-200 dark:ring-blue-800': ordersStatusFilter === 'all',
              'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600': ordersStatusFilter !== 'all'
            }">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                <mat-icon [svgIcon]="'tabler_outline:shopping-cart'" class="text-blue-600 dark:text-blue-400"></mat-icon>
              </div>
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Wszystkie</p>
                <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ orders.length }}</p>
              </div>
            </div>
          </div>
          
          <!-- Oczekujące -->
          <div 
            (click)="setOrdersStatusFilter('pending')"
            class="bg-card rounded-xl shadow-sm p-4 border-2 transition-all cursor-pointer hover:shadow-md"
            [ngClass]="{
              'border-amber-500 ring-2 ring-amber-200 dark:ring-amber-800': ordersStatusFilter === 'pending',
              'border-gray-200 dark:border-gray-700 hover:border-amber-300 dark:hover:border-amber-600': ordersStatusFilter !== 'pending'
            }">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg">
                <mat-icon [svgIcon]="'tabler_outline:clock'" class="text-amber-600 dark:text-amber-400"></mat-icon>
              </div>
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Oczekujące</p>
                <p class="text-2xl font-bold text-amber-600">{{ pendingOrdersCount }}</p>
              </div>
            </div>
          </div>
          
          <!-- Opłacone -->
          <div 
            (click)="setOrdersStatusFilter('paid')"
            class="bg-card rounded-xl shadow-sm p-4 border-2 transition-all cursor-pointer hover:shadow-md"
            [ngClass]="{
              'border-green-500 ring-2 ring-green-200 dark:ring-green-800': ordersStatusFilter === 'paid',
              'border-gray-200 dark:border-gray-700 hover:border-green-300 dark:hover:border-green-600': ordersStatusFilter !== 'paid'
            }">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                <mat-icon [svgIcon]="'tabler_outline:check'" class="text-green-600 dark:text-green-400"></mat-icon>
              </div>
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Opłacone</p>
                <p class="text-2xl font-bold text-green-600">{{ paidOrdersCount }}</p>
              </div>
            </div>
          </div>
          
          <!-- Przychód -->
          <div class="bg-card rounded-xl shadow-sm p-4 border border-gray-200 dark:border-gray-700">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg">
                <mat-icon [svgIcon]="'tabler_outline:currency-zloty'" class="text-purple-600 dark:text-purple-400"></mat-icon>
              </div>
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Przychód</p>
                <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ formatPrice(totalRevenue) }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Akcje do wykonania -->
        <div *ngIf="actionsRequiredCount > 0" class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <!-- Brak wygenerowanej faktury -->
          <div *ngIf="paidWithoutInvoiceCount > 0"
               class="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 rounded-xl p-4 border-2 border-amber-400 dark:border-amber-600 shadow-sm">
            <div class="flex items-center gap-4">
              <div class="p-3 bg-amber-100 dark:bg-amber-800/50 rounded-full">
                <mat-icon [svgIcon]="'tabler_outline:file-alert'" class="text-amber-600 dark:text-amber-400 icon-size-6"></mat-icon>
              </div>
              <div class="flex-1">
                <div class="flex items-center gap-2">
                  <span class="text-lg font-bold text-amber-700 dark:text-amber-300">{{ paidWithoutInvoiceCount }}</span>
                  <span class="text-sm font-medium text-amber-600 dark:text-amber-400">
                    {{ paidWithoutInvoiceCount === 1 ? 'zamówienie wymaga' : 'zamówień wymaga' }} wygenerowania faktury
                  </span>
                </div>
                <p class="text-xs text-amber-600/80 dark:text-amber-400/80 mt-1">
                  Opłacone zamówienia bez wygenerowanej faktury VAT
                </p>
              </div>
              <mat-icon [svgIcon]="'tabler_outline:alert-triangle'" class="text-amber-500 icon-size-5 animate-pulse"></mat-icon>
            </div>
          </div>

          <!-- Do wysłania do KSeF -->
          <div *ngIf="invoiceToSendToKsefCount > 0"
               class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-4 border-2 border-blue-400 dark:border-blue-600 shadow-sm">
            <div class="flex items-center gap-4">
              <div class="p-3 bg-blue-100 dark:bg-blue-800/50 rounded-full">
                <mat-icon [svgIcon]="'tabler_outline:send'" class="text-blue-600 dark:text-blue-400 icon-size-6"></mat-icon>
              </div>
              <div class="flex-1">
                <div class="flex items-center gap-2">
                  <span class="text-lg font-bold text-blue-700 dark:text-blue-300">{{ invoiceToSendToKsefCount }}</span>
                  <span class="text-sm font-medium text-blue-600 dark:text-blue-400">
                    {{ invoiceToSendToKsefCount === 1 ? 'faktura do wysłania' : 'faktury do wysłania' }} do KSeF
                  </span>
                </div>
                <p class="text-xs text-blue-600/80 dark:text-blue-400/80 mt-1">
                  Wygenerowane faktury oczekujące na wysłanie do KSeF
                </p>
              </div>
              <mat-icon [svgIcon]="'tabler_outline:clock'" class="text-blue-500 icon-size-5 animate-pulse"></mat-icon>
            </div>
          </div>
        </div>

        <!-- Orders Table -->
        <div class="bg-card rounded-2xl shadow-lg overflow-hidden">
          
          <!-- Table header -->
          <div class="p-6 border-b dark:border-gray-700">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Lista zamówień</h2>
                <span class="px-3 py-1 text-sm font-medium rounded-full bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                  {{ filteredOrders.length }}
                </span>
                <!-- Aktywny filtr -->
                <span *ngIf="ordersStatusFilter !== 'all'" 
                      class="px-3 py-1 text-xs font-semibold rounded-full inline-flex items-center gap-1"
                      [ngClass]="getOrderStatusClass(ordersStatusFilter)">
                  <mat-icon class="!w-3 !h-3 !text-xs" [svgIcon]="getOrderStatusIcon(ordersStatusFilter)"></mat-icon>
                  {{ getOrderStatusLabel(ordersStatusFilter) }}
                  <button 
                    (click)="setOrdersStatusFilter('all'); $event.stopPropagation()"
                    class="ml-1 hover:opacity-80">
                    <mat-icon [svgIcon]="'tabler_outline:x'" class="!w-3 !h-3"></mat-icon>
                  </button>
                </span>
                <!-- Aktywne wyszukiwanie -->
                <span *ngIf="ordersSearchTerm" 
                      class="px-3 py-1 text-xs font-semibold rounded-full bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-400 inline-flex items-center gap-1">
                  <mat-icon [svgIcon]="'tabler_outline:search'" class="!w-3 !h-3"></mat-icon>
                  "{{ ordersSearchTerm }}"
                  <button 
                    (click)="clearOrdersSearch(); $event.stopPropagation()"
                    class="ml-1 hover:opacity-80">
                    <mat-icon [svgIcon]="'tabler_outline:x'" class="!w-3 !h-3"></mat-icon>
                  </button>
                </span>
              </div>
              <!-- Wyczyść wszystkie filtry -->
              <button 
                *ngIf="ordersStatusFilter !== 'all' || ordersSearchTerm"
                mat-stroked-button
                (click)="ordersStatusFilter = 'all'; ordersSearchTerm = ''; filterOrders()"
                class="!rounded-lg text-sm">
                <mat-icon [svgIcon]="'tabler_outline:filter-off'" class="mr-1 icon-size-4"></mat-icon>
                Wyczyść filtry
              </button>
            </div>
          </div>

          <!-- Loading -->
          <div *ngIf="isOrdersLoading" class="p-12 text-center">
            <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
          </div>

          <!-- Empty state -->
          <div *ngIf="!isOrdersLoading && filteredOrders.length === 0" class="p-12 text-center">
            <mat-icon class="text-6xl text-gray-400 mb-4" [svgIcon]="'tabler_outline:shopping-cart'"></mat-icon>
            <h3 class="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">
              Brak zamówień
            </h3>
            <p class="text-gray-500 dark:text-gray-400">
              Zamówienia pojawią się tutaj po złożeniu przez użytkowników
            </p>
          </div>

          <!-- Table -->
          <div *ngIf="!isOrdersLoading && filteredOrders.length > 0" class="overflow-x-auto">
            <table mat-table [dataSource]="filteredOrders" class="w-full">

              <!-- Order Number Column -->
              <ng-container matColumnDef="orderNumber">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">Nr zamówienia</th>
                <td mat-cell *matCellDef="let order">
                  <span class="font-mono text-sm font-medium text-gray-900 dark:text-white">
                    {{ order.orderNumber }}
                  </span>
                </td>
              </ng-container>

              <!-- User Column -->
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef class="font-semibold">Użytkownik</th>
                <td mat-cell *matCellDef="let order">
                  <div>
                    <div class="font-medium text-gray-900 dark:text-white">
                      {{ order.invoiceData?.companyName || 'Brak nazwy' }}
                    </div>
                    <div class="text-sm text-gray-500 dark:text-gray-400">
                      NIP: {{ order.invoiceData?.nip || '-' }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Plan Column -->
              <ng-container matColumnDef="plan">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">Plan</th>
                <td mat-cell *matCellDef="let order">
                  <span 
                    class="px-3 py-1 rounded-full text-xs font-bold"
                    [ngClass]="getTypeColor(order.planStage)">
                    {{ getTypeLabel(order.planStage) }}
                  </span>
                </td>
              </ng-container>

              <!-- Amount Column -->
              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">Kwota</th>
                <td mat-cell *matCellDef="let order">
                  <span class="font-semibold text-gray-900 dark:text-white">
                    {{ formatPrice(order.amount) }}
                  </span>
                </td>
              </ng-container>

              <!-- Payment Method Column -->
              <ng-container matColumnDef="paymentMethod">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-40">Płatność</th>
                <td mat-cell *matCellDef="let order">
                  <div class="flex items-center gap-2">
                    <mat-icon 
                      [svgIcon]="order.paymentMethod === 'transfer' ? 'tabler_outline:building-bank' : 'tabler_outline:credit-card'"
                      class="icon-size-4 text-gray-500">
                    </mat-icon>
                    <span class="text-sm text-gray-600 dark:text-gray-300">
                      {{ getPaymentMethodLabel(order.paymentMethod) }}
                    </span>
                  </div>
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">Status</th>
                <td mat-cell *matCellDef="let order">
                  <span 
                    class="px-3 py-1 rounded-full text-xs font-semibold inline-flex items-center gap-1"
                    [ngClass]="getOrderStatusClass(order.status)">
                    <mat-icon class="!w-4 !h-4 !text-sm" [svgIcon]="getOrderStatusIcon(order.status)"></mat-icon>
                    {{ getOrderStatusLabel(order.status) }}
                  </span>
                </td>
              </ng-container>

              <!-- Date Column -->
              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-40">Data</th>
                <td mat-cell *matCellDef="let order">
                  <span class="text-sm text-gray-600 dark:text-gray-300">
                    {{ formatDate(order.createdAt) }}
                  </span>
                </td>
              </ng-container>

              <!-- Invoice Column -->
              <ng-container matColumnDef="invoice">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">Faktura</th>
                <td mat-cell *matCellDef="let order">
                  <span *ngIf="order.invoiceGenerated" class="text-green-600 dark:text-green-400 flex items-center gap-1">
                    <mat-icon [svgIcon]="'tabler_outline:file-invoice'" class="icon-size-4"></mat-icon>
                    Tak
                  </span>
                  <span *ngIf="!order.invoiceGenerated && order.status === 'paid'" 
                        class="text-amber-600 dark:text-amber-400 flex items-center gap-1">
                    <mat-icon [svgIcon]="'tabler_outline:alert-circle'" class="icon-size-4"></mat-icon>
                    Brak
                  </span>
                  <span *ngIf="order.status !== 'paid'" class="text-gray-400">-</span>
                </td>
              </ng-container>

              <!-- KSeF Column -->
              <ng-container matColumnDef="ksef">
                <th mat-header-cell *matHeaderCellDef class="font-semibold w-32">KSeF</th>
                <td mat-cell *matCellDef="let order">
                  <!-- Faktura wysłana do KSeF -->
                  <span *ngIf="order.ksefNumber" 
                        class="text-green-600 dark:text-green-400 flex items-center gap-1"
                        [matTooltip]="order.ksefNumber">
                    <mat-icon [svgIcon]="'tabler_outline:check'" class="icon-size-4"></mat-icon>
                    Wysłano
                  </span>
                  <!-- Faktura wygenerowana ale nie wysłana do KSeF -->
                  <span *ngIf="order.invoiceGenerated && !order.ksefNumber"
                        class="text-amber-600 dark:text-amber-400 flex items-center gap-1">
                    <mat-icon [svgIcon]="'tabler_outline:send'" class="icon-size-4"></mat-icon>
                    Do wysłania
                  </span>
                  <!-- Brak faktury -->
                  <span *ngIf="!order.invoiceGenerated" class="text-gray-400">-</span>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="font-semibold text-right w-32"></th>
                <td mat-cell *matCellDef="let order" class="text-right" (click)="$event.stopPropagation()">
                  <button 
                    mat-icon-button
                    [matMenuTriggerFor]="orderMenu"
                    matTooltip="Akcje">
                    <mat-icon [svgIcon]="'tabler_outline:dots-vertical'"></mat-icon>
                  </button>
                  <mat-menu #orderMenu="matMenu">
                    <button mat-menu-item (click)="viewOrderDetails(order)">
                      <mat-icon [svgIcon]="'tabler_outline:eye'"></mat-icon>
                      <span>Szczegóły</span>
                    </button>
                    <button mat-menu-item *ngIf="order.status === 'pending'" (click)="markOrderAsPaid(order)">
                      <mat-icon [svgIcon]="'tabler_outline:check'" class="text-green-600"></mat-icon>
                      <span>Oznacz jako opłacone</span>
                    </button>
                    <button mat-menu-item *ngIf="order.status === 'pending'" (click)="cancelOrder(order)">
                      <mat-icon [svgIcon]="'tabler_outline:x'" class="text-red-500"></mat-icon>
                      <span>Anuluj zamówienie</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item *ngIf="order.status === 'paid' && !order.invoiceGenerated" (click)="generateInvoice(order)">
                      <mat-icon [svgIcon]="'tabler_outline:file-invoice'"></mat-icon>
                      <span>Generuj fakturę</span>
                    </button>
                    <button mat-menu-item *ngIf="order.invoiceId" (click)="viewInvoice(order)">
                      <mat-icon [svgIcon]="'tabler_outline:file-text'"></mat-icon>
                      <span>Zobacz fakturę</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="ordersDisplayedColumns"></tr>
              <tr 
                mat-row 
                *matRowDef="let row; columns: ordersDisplayedColumns;" 
                (click)="viewOrderDetails(row)"
                [ngClass]="{
                  'bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30': isOldPendingOrder(row),
                  'hover:bg-gray-50 dark:hover:bg-gray-800': !isOldPendingOrder(row)
                }"
                class="transition-colors cursor-pointer"></tr>
            </table>
          </div>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>

</div>
